// extracted by mini-css-extract-plugin
export default {"popup":"Map--popup--Yvu37","close-btn":"Map--close-btn--uY0L4","closeBtn":"Map--close-btn--uY0L4"};